<template>
  <div class="linkClick">
		<el-link
			:type="tableData.style || 'primary'"
			:underline="false"
			@click="click(tableData)"
			:disabled="tableData.disabled && tableData.disabled(scope, tableData)"
			>{{ scope.row[tableData.bind] }}</el-link
		>
	</div>
</template>
<script>
export default {
  name: "linkClick",
  props: ["tableData", "scope"],
  data() {
    return {};
  },
  methods: {
    click(val) {
			val.click && val.click(this.scope, this.tableData, this);
		}
  },
  mounted() {}
};
</script>
<style lang="scss">
.linkClick {
  .el-link {
    width: 100%;
    .el-link--inner {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: auto;
    }
  }
}
</style>